// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});

export function dropdown1_change(event) {
	//Add your code for this event here: 
}

export function dropdown2_click(event) {
	//Add your code for this event here: 
}